/*
 * Contracts Dashboard  Messages
 *
 * This contains all the text for the Contracts dashboard.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.ContractsPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Contracts',
  },
  studentLabel: {
    id: `${scope}.studentLabel`,
    defaultMessage: 'Student',
  },
  jobIdLabel: {
    id: `${scope}.jobIdLabel`,
    defaultMessage: 'Job ID',
  },
  contractIdLabel: {
    id: `${scope}.contractIdLabel`,
    defaultMessage: 'Contract ID',
  },
  customerLabel: {
    id: `${scope}.customerLabel`,
    defaultMessage: 'Customer',
  },
  startDateLabel: {
    id: `${scope}.startDateLabel`,
    defaultMessage: 'Start Date',
  },
  endDateLabel: {
    id: `${scope}.endDateLabel`,
    defaultMessage: 'End Date',
  },
  cancellationRequestedDateLabel: {
    id: `${scope}.cancellationRequestedDateLabel`,
    defaultMessage: 'Cancel Req. On',
  },
  daysLeftLabel: {
    id: `${scope}.daysLeftLabel`,
    defaultMessage: 'Days Left',
  },
  signingMethodLabel: {
    id: `${scope}.signingMethodLabel`,
    defaultMessage: 'Signing Method',
  },
  studentSignedLabel: {
    id: `${scope}.studentSignedLabel`,
    defaultMessage: 'Student Signed',
  },
  ucmSignedLabel: {
    id: `${scope}.ucmSignedLabel`,
    defaultMessage: 'UCM Signed',
  },
  statusLabel: {
    id: `${scope}.statusLabel`,
    defaultMessage: 'Status',
  },
  signatureStatusLabel: {
    id: `${scope}.signatureStatusLabel`,
    defaultMessage: 'Signature Status',
  },
  archiveIdLabel: {
    id: `${scope}.archiveIdLabel`,
    defaultMessage: 'Archive ID',
  },
  projectTypeLabel: {
    id: `${scope}.projectTypeLabel`,
    defaultMessage: 'Project Type',
  },
  contractSaved: {
    id: `${scope}.contractSaved`,
    defaultMessage: 'Contract saved successfully',
  },
  editTooltip: {
    id: `${scope}.editTooltip`,
    defaultMessage: 'Edit',
  },
  downloadTooltip: {
    id: `${scope}.downloadTooltip`,
    defaultMessage: 'Download',
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage: 'Delete',
  },
  contractDownloaded: {
    id: `${scope}.contractDownloaded`,
    defaultMessage: 'Contract downloaded successfully',
  },
  contractDeleted: {
    id: `${scope}.contractDeleted`,
    defaultMessage: 'Contract deleted successfully',
  },
  deleteContractConfirmMessage: {
    id: `${scope}.deleteContractConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete this contract?',
  },
  searchUserIdPlaceholder: {
    id: `${scope}.searchUserIdPlaceholder`,
    defaultMessage: 'UID',
  },
  searchJobIdPlaceholder: {
    id: `${scope}.searchJobIdPlaceholder`,
    defaultMessage: 'JID',
  },
  searchProjectIdPlaceholder: {
    id: `${scope}.searchProjectIdPlaceholder`,
    defaultMessage: 'PID',
  },
  searchContractIdPlaceholder: {
    id: `${scope}.searchContractIdPlaceholder`,
    defaultMessage: 'CID',
  },
  longTerm: {
    id: `${scope}.longTerm`,
    defaultMessage: 'Long Term',
  },
  shortTerm: {
    id: `${scope}.shortTerm`,
    defaultMessage: 'Short Term',
  },
  contractCreated: {
    id: `${scope}.contractCreated`,
    defaultMessage: 'Contract created successfully',
  },
  contractActivated: {
    id: `${scope}.contractActivated`,
    defaultMessage: 'Contract activated successfully',
  },
  signatureRequested: {
    id: `${scope}.signatureRequested`,
    defaultMessage: 'Signature requested successfully',
  },
  requestSignatureTooltip: {
    id: `${scope}.requestSignatureTooltip`,
    defaultMessage: 'Request Signature',
  },
  signByUcmTooltip: {
    id: `${scope}.signByUcmTooltip`,
    defaultMessage: 'Sign by UCM',
  },
  confirmSignMessage: {
    id: `${scope}.confirmSignMessage`,
    defaultMessage: 'Are you sure you want to sign this contract with “{name}”',
  },
  signedByUcm: {
    id: `${scope}.signedByUcm`,
    defaultMessage: 'Signed by UCM successfully',
  },
  contractsArchived: {
    id: `${scope}.contractsArchived`,
    defaultMessage: 'Contracts archived successfully',
  },
  contractsArchiveFailedPart1: {
    id: `${scope}.contractsArchiveFailedPart1`,
    defaultMessage: 'Some contracts failed archiving',
  },
  contractsArchiveFailedPart2: {
    id: `${scope}.contractsArchiveFailedPart2`,
    defaultMessage: 'Please, check the downloaded file',
  },
  contractCancelled: {
    id: `${scope}.contractCancelled`,
    defaultMessage: 'Contract cancelled successfully',
  },
  reinstateTooltip: {
    id: `${scope}.reinstateTooltip`,
    defaultMessage: 'Reinstate to physical contract',
  },
  confirmReinstateMessage: {
    id: `${scope}.confirmReinstateMessage`,
    defaultMessage:
      'Are you sure you want to reinstate this contract to physical contract?',
  },
  reinstateSuccess: {
    id: `${scope}.reinstateSuccess`,
    defaultMessage: 'Contract reinstated to physical contract successfully',
  },
});
